"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSearch = AddressSearch;
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var ban_1 = require("../ban");
var signals_1 = require("@preact/signals");
function asSelect2Option(p) {
    return {
        id: JSON.stringify(p),
        text: p.label,
    };
}
function initSelect(element, precision) {
    var url = new URL(ban_1.BAN_URL);
    url.searchParams.set('type', precision);
    return $(element).select2({
        theme: 'bootstrap-5',
        minimumInputLength: 3,
        placeholder: 'Rechercher une adresse dans la base d’adresses nationale…',
        ajax: {
            url: url.href,
            dataType: 'json',
            delay: 800,
            processResults: function (data) {
                var results = data.features.map(function (p) { return asSelect2Option(p.properties); });
                return { results: results };
            },
        },
    });
}
function pick(signal, key) {
    return (0, signals_1.useComputed)(function () { var _a; return signal.value ? String((_a = signal.value[key]) !== null && _a !== void 0 ? _a : '') : ''; });
}
function missing(signal, key) {
    return (0, signals_1.useComputed)(function () { return !signal.value || !signal.value[key]; });
}
function AddressSearch(_a) {
    var zid = _a.zid, zname = _a.zname, errored = _a.errored, required = _a.required, precision = _a.precision;
    var input = (0, hooks_1.useRef)(null);
    var selected = (0, signals_1.useSignal)(null);
    var picked = [
        'id',
        'housenumber',
        'city',
        'context',
        'postcode',
        'street',
        'type',
        'locality',
    ];
    (0, hooks_1.useEffect)(function () {
        if (!input.current) {
            return;
        }
        initSelect(input.current, precision).on('select2:select', function () {
            selected.value = JSON.parse(input.current.value);
        });
    }, [input]);
    return (0, jsx_runtime_1.jsxs)("div", { children: [picked.map(function (key) {
                return (0, jsx_runtime_1.jsx)("input", { type: 'hidden', name: "".concat(zname, "[").concat(key, "]"), value: pick(selected, key), disabled: missing(selected, key) }, key);
            }), (0, jsx_runtime_1.jsx)("select", { id: zid, class: 'w-100 form-select', ref: input, required: Boolean(required), "aria-invalid": Boolean(errored), "aria-errormessage": errored })] });
}
